import { render, staticRenderFns } from "./authorizationshop-cancel.vue?vue&type=template&id=5ba92f17&scoped=true"
import script from "./authorizationshop-cancel.vue?vue&type=script&lang=ts"
export * from "./authorizationshop-cancel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba92f17",
  null
  
)

export default component.exports